export default "__VITE_ASSET__BXZFbdKv__"